const LogsWidget = () => {
  return <>Log Log Log Log Log Log</>;
};

export default LogsWidget;
